import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import _Address from '@piconetworks/pkg-field-address';
import _Dropdown from '@piconetworks/pkg-field-dropdown';
import _Number from '@piconetworks/pkg-field-number';
import _Radio from '@piconetworks/pkg-field-radio';
import _Boolean from '@piconetworks/pkg-field-boolean';
import _Checkbox from '@piconetworks/pkg-field-checkbox';
import _Date from '@piconetworks/pkg-field-date';
import _Text from '@piconetworks/pkg-field-text';
import FieldLinks from '@piconetworks/pkg-field-link';
import Preview from '@piconetworks/pkg-preview';

var _excluded = ["type", "id", "title"];
var typeMap = {
  Date: function Date(_ref2) {
    var name = _ref2.name,
      label = _ref2.label,
      description = _ref2.description,
      required = _ref2.required;
    return /*#__PURE__*/React.createElement(_Date, {
      fieldContainerProps: {
        label: label,
        required: required
      },
      name: name,
      description: description,
      required: required
    });
  },
  Dropdown: function Dropdown(_ref3) {
    var name = _ref3.name,
      label = _ref3.label,
      description = _ref3.description,
      required = _ref3.required,
      defaultValue = _ref3.defaultValue,
      options = _ref3.options;
    return /*#__PURE__*/React.createElement(_Dropdown, {
      fieldContainerProps: {
        label: label,
        required: required
      },
      name: name,
      description: description,
      required: required,
      defaultValue: defaultValue,
      options: options
    });
  },
  Address: function Address(_ref4) {
    var name = _ref4.name,
      label = _ref4.label,
      description = _ref4.description,
      required = _ref4.required,
      defaultValue = _ref4.defaultValue;
    return /*#__PURE__*/React.createElement(_Address, {
      fieldContainerProps: {
        label: label,
        required: required
      },
      name: name,
      description: description,
      required: required,
      defaultValue: defaultValue
    });
  },
  Text: function Text(_ref5) {
    var name = _ref5.name,
      label = _ref5.label,
      description = _ref5.description,
      required = _ref5.required,
      defaultValue = _ref5.defaultValue;
    return /*#__PURE__*/React.createElement(_Text, {
      fieldContainerProps: {
        label: label,
        required: required
      },
      name: name,
      description: description,
      required: required,
      defaultValue: defaultValue
    });
  },
  Link: function Link(_ref6) {
    var name = _ref6.name,
      description = _ref6.description,
      required = _ref6.required,
      linkBlocks = _ref6.linkBlocks,
      linkColor = _ref6.linkColor,
      onLinkClink = _ref6.onLinkClink,
      richMediaData = _ref6.richMediaData;
    return /*#__PURE__*/React.createElement(FieldLinks, {
      fieldContainerProps: {
        required: required
      },
      name: name,
      description: description,
      linkBlocks: linkBlocks,
      linkColor: linkColor,
      onLinkClink: onLinkClink,
      richMediaData: richMediaData
    });
  },
  Number: function Number(_ref7) {
    var name = _ref7.name,
      label = _ref7.label,
      description = _ref7.description,
      required = _ref7.required,
      defaultValue = _ref7.defaultValue;
    return /*#__PURE__*/React.createElement(_Number, {
      fieldContainerProps: {
        label: label,
        required: required
      },
      name: name,
      description: description,
      required: required,
      defaultValue: defaultValue
    });
  },
  Radio: function Radio(_ref8) {
    var name = _ref8.name,
      label = _ref8.label,
      description = _ref8.description,
      required = _ref8.required,
      options = _ref8.options;
    return /*#__PURE__*/React.createElement(_Radio, {
      fieldContainerProps: {
        label: label,
        required: required
      },
      name: name,
      description: description,
      required: required,
      options: options
    });
  },
  Boolean: function Boolean(_ref9) {
    var name = _ref9.name,
      label = _ref9.label,
      description = _ref9.description,
      required = _ref9.required,
      options = _ref9.options;
    return /*#__PURE__*/React.createElement(_Boolean, {
      fieldContainerProps: {
        label: label,
        required: required
      },
      name: name,
      description: description,
      required: required,
      options: options
    });
  },
  Checkbox: function Checkbox(_ref10) {
    var name = _ref10.name,
      label = _ref10.label,
      description = _ref10.description,
      required = _ref10.required,
      options = _ref10.options;
    return /*#__PURE__*/React.createElement(_Checkbox, {
      fieldContainerProps: {
        label: label,
        required: required
      },
      name: name,
      description: description,
      required: required,
      options: options
    });
  }
};
var getFields = function getFields(fields, prefix) {
  if (prefix === void 0) {
    prefix = '';
  }
  return fields.filter(function (_ref11) {
    var type = _ref11.type,
      id = _ref11.id;
    return !!type && !!typeMap[type] && !!id;
  }).sort(function (_ref12, _ref13) {
    var a = _ref12.order;
    var b = _ref13.order;
    return a - b;
  }).map(function (_ref14) {
    var type = _ref14.type,
      id = _ref14.id,
      title = _ref14.title,
      rest = _objectWithoutPropertiesLoose(_ref14, _excluded);
    var Field = typeMap[type];
    return function (props) {
      return /*#__PURE__*/React.createElement(Preview, null, /*#__PURE__*/React.createElement(Field, _extends({
        name: "" + (prefix ? prefix + "." : '') + id,
        label: title
      }, rest, props)));
    };
  });
};

export { getFields as default };
//# sourceMappingURL=getFields.js.map
